import { axiosInstance } from '@/modules/shared/lib/axios'
import { UserListRequestPayload, UserListResponse } from './types'

type Props = {
  companyId: string
  payload?: UserListRequestPayload
}

export function getAdminUsers({ companyId, payload }: Props) {
  // Build query params to match legacy API format
  const params: any = {
    paged: true,
    take: payload?.take || 10,
    skip: payload?.skip || 0,
    orderBy: payload?.orderBy || 'createdDate',
    descending: payload?.descending !== undefined ? payload.descending : true,
    searchValue: payload?.searchValue || '',
    onlyBlocked:
      payload?.onlyBlocked !== undefined ? payload.onlyBlocked : false,
  }

  // Panel admina otwarty bez firmy pyta o użytkowników ze wszystkich firm - wtedy
  // `companyId` i `tenantId` muszą wypaść z zapytania, tak jak robił to stary panel.
  if (companyId) {
    params.companyId = companyId
    params.tenantId = payload?.tenantId || ''
  }

  if (payload?.groupId) params.groupId = payload.groupId

  // Add individual field filters if provided
  if (payload?.login) params.login = payload.login
  if (payload?.firstName) params.firstName = payload.firstName
  if (payload?.lastName) params.lastName = payload.lastName
  if (payload?.role?.id) params.roleId = payload.role.id

  return axiosInstance.get<UserListResponse>(`/config-api/user/list`, {
    params,
  })
}
